/*
Author: Samir Dasarwad
Date: 09/12/2020

*/

<template>
  <div class="business">
    <div class="top-bar">
      <span @click="goToLevelsPage">
        <img src="@/assets/path-2-copy.png" />
      </span>
      <span class="heading_new">{{heading}}</span>
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <pop-up-message
      v-if="showSuccessMsg"
      :message="`${instance.name} has been successfully ${editMode ? 'updated' : 'created'}`"
      btnText="Back To Levels"
      @back="backfrompopup()"
    />

    <div class="content-new">
      <div class="addflexispace" v-if="!editMode">
        <tl-radio
          name="uploadMethod"
          label="Bulk Upload"
          id="bulkUpload"
          value="bulkUpload"
          v-model="uploadMethod"
        />
        <tl-radio
          name="uploadMethod"
          label="Manual"
          id="manualUpload"
          value="manualUpload"
          v-model="uploadMethod"
        />
      </div>

      <div class="row margin-t-l" v-if="uploadMethod == 'bulkUpload'">
        <div class="col-12 padding-l-n download-btn">
          <div class="download-btn-container">
            <img src="@/assets/download.svg"  class="img" />
            <span class="text" @click="downloadUrl">Download Template</span>
            <loading-animation v-show="showLoader"></loading-animation>
         </div>
        </div>
        <div class="col-12 padding-l-n margin-t-15px">
          <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />
        </div>
      </div>

      <div v-else>
        <form action class="form" v-if="instance">
          <div class="row">
            <div class="col-3 padding-l-n margin-t-l">
              <txt
                autofocus="autofocus"
                label="Name *"
                type="text"
                v-model="instance.name"
                name="name"
                v-validate="{required: true, max: nameMaxlength}"
                :classname="errors.has('name')"
                :errormsg="errors.first('name')"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-3 padding-l-n margin-t-m">
              <txt
                label="Description"
                type="textarea"
                v-model="instance.description"
                name="description"
                v-validate="{required: false, max: descriptionMaxlength}"
                :classname="errors.has('description')"
                :errormsg="errors.first('description')"
              />
            </div>
          </div>
        </form>
      </div>

      <pop-up-message
        v-if="showSuccessBulkUploadMsg"
        :message="responseMsg"
        btnText="Back To Levels"
        @back="goToLevelsPage"
      ></pop-up-message>

      <bottom-action-container class="placeEnd">
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" v-on:click="goToLevelsPage"></btn>
            <btn :text="submitFormText" type="primary" v-on:click="submit"></btn>
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { createDecipheriv } from 'crypto';
import { ErrorMesages } from "../../../../../../apis/constants.js";
import * as config from "@/apis/config.js";
import { api_variables } from "@/apis/variables.js";
import axios from "axios";
import {S3} from "aws-sdk";
export default {
  data() {
    return {
      showLoader: false,
      bulkUploadTemplateUrl:'https://paylief.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/level.xlsx',
      bulkUploadUrl: api_variables.SERVICE_LEVELS_UPLOAD_TEMPLATE,
      nameMaxlength: null,
      descriptionMaxlength: null,
      responseMsg: "",
      showSuccessBulkUploadMsg: false,
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      uploadMethod: "manualUpload",
      //PL-2267
      instance: {
        name: "",
        descripion: ""
      }
      //PL-2267
    };
  },
  computed: {
    ...mapState("onboard/levels", {
      levelsDataAll: state => state.entityWiseData,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID",
      record: "onboard/levels/record"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
    },
    levelsData() {
      return this.levelsDataAll[this.leId];
    },
    isLoading() {
      return this.isFetching;
    },
    editMode() {
      return this.$store.getters["onboard/levels/editMode"];
    },
    submitFormText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Add New Level";
      }
    },

    heading() {
      if (this.editMode) {
        this.uploadMethod = "manualUpload";
        return "Level" + " - " + this.instance.name;
      } else {
        this.uploadMethod = "manualUpload";
        return "Add Levels";
      }
    }
  },
  activated() {
    this.toast = false;
    this.setGlobalValidations();
    //Start PL-2267
    this.uploadMethod = "manualUpload";
    if (this.editMode) {
      this.uploadMethod = "manualUpload";
      this.instance = this.record;
    } else {
      this.refresh();
    }
    //End PL-2267
  },
  methods: {
    ...mapActions("onboard/levels/", {
      act_create: "create",
      act_update: "update",
      act_upload_template: "uploadTemplate"
    }),
    ...mapActions("payroll/lopsandrlops/", {
    getPreSignedUrl: "createPreSigned"
  }),
  async preSignedUrlFunction() {
  try {
    let res = await this.getPreSignedUrl({
      url: this.bulkUploadTemplateUrl
    });
    if (res.data.payload && res.data.payload.iv && res.data.payload.encryptedPacket) {
      const decryptedLink = await this.decrypt(res.data.payload);
      return decryptedLink;
    } else {
      console.log('Invalid payload structure');
      return null;
    } 
  } catch (e) {
    console.log('Error in preSignedUrlFunction:', e);
    return null; 
  }
},
    async downloadUrl() {
      try {
        const downloadLink = await this.preSignedUrlFunction();
        if (downloadLink) {
          let url = JSON.parse(downloadLink);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Levels.xls"); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          console.log('Failed to retrieve the download link.');
        }
      } catch (e) {
        console.error('Error during download:', e);
      }
    },
    async decrypt(payload){
    const key = process.env.VUE_APP_PAYSLIP_SECRET;
    const decipher = createDecipheriv('aes-256-cbc', key, Buffer.from(payload.iv, 'hex'));
    const decrypted = Buffer.concat([
        decipher.update(payload.encryptedPacket, 'base64'),
        decipher.final()
    ]);

    return decrypted.toString();
},
   
    /* function to set default configuration for validation */
    setGlobalValidations(){
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.descriptionMaxlength = config.MaxLengthSettings.descriptionLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get response after uploading in bulk */
    async onUploadTemplate(res) {
      try {
          if (res.data && res.status) {
            this.responseMsg =  "Level added Succesfully";
            this.showSuccessBulkUploadMsg = true;
          } else {
            this.toast = true;
            this.errmsg = res.response.data.message;
          }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to go to Level main page */
    goToLevelsPage() {
      this.refresh();
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/level`
      });
    },

    /* function to refres the page */
    refresh() {
      try {
        this.errmsg = "";
        this.toast = false;
        this.showSuccessBulkUploadMsg = false;
        this.instance = {
          name: "",
          descripion: ""
        };
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to hide the success pop-up and go back to Level main page */
    backfrompopup() {
      this.refresh();
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/level`
      });
    },

    /* function to validate from */
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    },

    /* server call to create or update levels */
    async performAction() {
      try {
        if (!this.$_.isEmpty(this.instance.name)) {
          this.$root._data.isSaving = true;
          let res = null;
          if (this.editMode) {
            this.instance.name = this.instance.name.toString().trim();
            res = await this.act_update([{ data: this.instance }, this.leId]);
          } else {
            let formData = {
              name: this.instance.name.toString().trim(),
              description: this.instance.description,
              le_id: this.leId
            };
            res = await this.act_create({ data: formData });
          }
          if (res.data.status) {
            this.$root._data.isSaving = false;
            this.showSuccessMsg = true;
          }
        } else {
          this.toast = true;
          this.errmsg = ErrorMesages.nameError;
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
@import "@/scss/components/form.scss";
@import "../../../../../../scss/variables";
.download-btn-container {
  display: flex;
  align-items: normal;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    color: $color-secondary;
    margin-left: 8px;
    cursor: pointer;
  }
}
.content-new {
  margin: 32px 0 0 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
}

.business {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.top-bar {
  height: 64px;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 0 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

.addflexispace {
  display: flex;
}
</style>
